import PropTypes from "prop-types";
import React from "react";

import {APIError} from "v2/api/Records";

const ServerError = (props) => {
  return (
    <div className="erg-margin-15 text-danger">
      <h3>Server Error</h3>
      {props.children ? props.children : props.data.message}
    </div>
  );
};

ServerError.propTypes = {
  children: PropTypes.node,
  data: PropTypes.instanceOf(APIError),
};

export default ServerError;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/ServerError.js
 **/